import { penNameService } from './penNameService'

/**
 * The pen-name module façade. No store: the author pages and the publisher's own list each load what
 * they show, and a pen name is never shared state between them.
 */
export const usePenName = () => {
  return {
    penName: {
      service: penNameService()
    }
  }
}
